import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
  rowWrapped: {
    margin: '20px',
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    marginRight: '10px',
  },
  actionStyled: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  facilityWrapped: {
    display: 'flex',
    flexDirection: 'column',
  },
  enrollmentsWrapped: {
    marginLeft: '40px',
    display: 'flex',
    alignItems: 'center',
  },
}))
